var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.details && _vm.details.name.length > 30 ? _vm.details.name : null,
    html: false
  }),expression:"{\n    content: details && details.name.length > 30 ? details.name : null,\n    html: false\n  }"}],staticClass:"pin-text is-pointer",on:{"click":function($event){$event.stopPropagation();return _vm.go_back()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-10"}),_vm._v(" "+_vm._s(_vm.details && _vm.details.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }